(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mh-rich-content"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var wraps = document.querySelectorAll('.mh_rich_table_wrap');

    wraps.forEach(function (wrap) {
      var indicator = document.createElement('div');
      indicator.className = 'mh_scroll_indicator';

      var thumb = document.createElement('div');
      thumb.className = 'mh_scroll_indicator_thumb';
      indicator.appendChild(thumb);

      wrap.insertAdjacentElement('afterend', indicator);

      function update() {
        var maxScroll = wrap.scrollWidth - wrap.clientWidth;

        if (maxScroll <= 2) {
          indicator.classList.remove('mh_scroll_indicator--visible');
          return;
        }

        indicator.classList.add('mh_scroll_indicator--visible');

        var thumbWidthPercent = (wrap.clientWidth / wrap.scrollWidth) * 100;
        var scrollPercent = wrap.scrollLeft / maxScroll;
        var maxOffsetPercent = 100 - thumbWidthPercent;

        thumb.style.width = thumbWidthPercent + '%';
        thumb.style.marginLeft = scrollPercent * maxOffsetPercent + '%';
      }

      wrap.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["srs-floating-tt-bar-bottom"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target.closest('[data-srs-floating-checkout]');
      if (!form) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      var button = form.querySelector('.srs-floating-bar-bottom__cta');
      if (button) button.disabled = true;

      fetch(form.getAttribute('data-clear-url'), {
        method: 'POST',
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      })
        .then(function () {
          return fetch(form.getAttribute('data-add-url'), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            credentials: 'same-origin',
            body: JSON.stringify({
              id: Number(form.getAttribute('data-variant-id')),
              quantity: 1,
            }),
          });
        })
        .then(function (response) {
          if (!response.ok) throw new Error('add');
          window.location.href = form.getAttribute('data-checkout-url');
        })
        .catch(function () {
          form.submit();
        });
    },
    true
  );

  (function () {
    var bars = document.querySelectorAll('[data-floating-bar-root]');
    if (!bars.length) return;

    bars.forEach(function (bar) {
      var triggerId = (bar.getAttribute('data-trigger-id') || '').trim();

      if (!triggerId) {
        bar.classList.add('is-visible');
        return;
      }

      var triggerElement = document.getElementById(triggerId);
      if (!triggerElement) {
        bar.classList.add('is-visible');
        return;
      }

      var updateVisibility = function () {
        var rect = triggerElement.getBoundingClientRect();
        var hasPassedTrigger = rect.bottom <= 0;
        bar.classList.toggle('is-visible', hasPassedTrigger);
      };

      updateVisibility();
      window.addEventListener('scroll', updateVisibility, { passive: true });
      window.addEventListener('resize', updateVisibility);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["srs-hero-team-training"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var button = event.target.closest('.srs-hero-team-taining .srs-btn');
    if (!button) return;

    var fileUrl = button.getAttribute('href');
    if (!fileUrl || fileUrl === '#') return;

    event.preventDefault();

    var fileName = button.getAttribute('download') || 'brochure.pdf';

    fetch(fileUrl)
      .then(function (response) {
        if (!response.ok) throw new Error('download-failed');
        return response.blob();
      })
      .then(function (blob) {
        var objectUrl = URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = objectUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(objectUrl);
      })
      .catch(function () {
        var fallback = document.createElement('a');
        fallback.href = fileUrl;
        fallback.setAttribute('download', fileName);
        fallback.style.display = 'none';
        document.body.appendChild(fallback);
        fallback.click();
        fallback.remove();
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["srs-long-team-training"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target.closest('[data-srs-direct-checkout]');
      if (!form) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      var button = form.querySelector('.srs-cta');
      if (button) button.disabled = true;

      fetch(form.getAttribute('data-clear-url'), {
        method: 'POST',
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      })
        .then(function () {
          return fetch(form.getAttribute('data-add-url'), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            credentials: 'same-origin',
            body: JSON.stringify({
              id: Number(form.getAttribute('data-variant-id')),
              quantity: 1,
            }),
          });
        })
        .then(function (response) {
          if (!response.ok) throw new Error('add');
          window.location.href = form.getAttribute('data-checkout-url');
        })
        .catch(function () {
          form.submit();
        });
    },
    true
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["srs-pricing-team-training"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target.closest('[data-srs-direct-checkout]');
      if (!form) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      var button = form.querySelector('.srs-cta');
      if (button) button.disabled = true;

      fetch(form.getAttribute('data-clear-url'), {
        method: 'POST',
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      })
        .then(function () {
          return fetch(form.getAttribute('data-add-url'), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            credentials: 'same-origin',
            body: JSON.stringify({
              id: Number(form.getAttribute('data-variant-id')),
              quantity: 1,
            }),
          });
        })
        .then(function (response) {
          if (!response.ok) throw new Error('add');
          window.location.href = form.getAttribute('data-checkout-url');
        })
        .catch(function () {
          form.submit();
        });
    },
    true
  );

  } catch(e) { console.error(e); }
})();
})();
